(function() {
    'use strict';

    angular
        .module('updateClientApp')
        .controller('UpdateClientDialogController', UpdateClientDialogController);

    UpdateClientDialogController.$inject = ['$scope', '$uibModalInstance','items','$uibModal','NgTableParams','GLOBAL_URL','$base64','CustomerService','CommonService'];

    function UpdateClientDialogController ($scope, $uibModalInstance,  items,$uibModal, NgTableParams,GLOBAL_URL, $base64, CustomerService,CommonService) {
    	var updateClientDlgCtrl = this;
		var data = items;
		updateClientDlgCtrl.lstProvince = CommonService.query({masterurl:'province'});
		var url = 'ga/adjustaddress/#/customaddress';
		updateClientDlgCtrl.items = items;
		CommonService.query({masterurl:'district',provinceCode:items.provinceCode},function(resultDistrict){
			updateClientDlgCtrl.lstDistrict = resultDistrict;
		},function(error) {
		});
		CommonService.query({masterurl:'ward',districtCode:items.districtCode},function(resultWard){
			updateClientDlgCtrl.lstWard = resultWard;
		},function(error) {
		});
		updateClientDlgCtrl.tableParams = new NgTableParams({
			page : 1, // show first page
			count : 10
		// count per page
		}, {
			filterDelay : 0,
			dataset : data
		});

		updateClientDlgCtrl.ok = ok;
		updateClientDlgCtrl.cancel = cancel;
		function ok() {
			if (items.policyNum != '' && items.policyNum != null
					&& items.policyNum != undefined) {
				window.open(GLOBAL_URL + url + '/'
						+ $base64.encode(items.policyNum),'_self');
			}
		};

		function cancel() {
			if(items.clientCode != null && items.clientCode != undefined){
				CustomerService.get({uri:'update-date-las-client',clientCode:items.clientCode,policyNum:items.policyNum,clientName:items.fullName,address:items.address,cityDesc:items.cityDesc}, function(result){
					
				});
			}
			$uibModalInstance.dismiss('cancel');
		};
    	  
    }
})();
